import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import OAuthButtonV2 from 'components/OAuthButtonV2'
import { propFunc } from 'util/functions'
import Heading from 'subapps/onboarding/layout/Heading'
import { doCreateAffiliateClick } from 'ducks/affiliates/operations'
import { isAuthenticatedSelector } from 'selectors/app'
import {
  mail as Mail,
  googleLogoAlt as GoogleLogo,
} from 'assets/icons/groove/v2'
import { doGoogleSignup, doEmailSignup } from './actions'
import { doRedirectIfAuthenticated } from '../actions'
import { styles } from './styles'

const getTracking = (type = 'Gmail') => ({
  category: 'oAuth-onboarding',
  action: 'oAuth-account-creation',
  label: `oAuth-creation-${type}`,
})

const SignupPage = () => {
  const [saving, setSaving] = useState(false)
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(isAuthenticatedSelector)

  useEffect(
    () => {
      dispatch(doRedirectIfAuthenticated(true))
    },
    [dispatch]
  )

  useEffect(
    () => {
      if (!isAuthenticated) {
        dispatch(doCreateAffiliateClick())
      }
    },
    [dispatch, isAuthenticated]
  )

  const doSignup = useCallback(
    (action, type) => {
      setSaving(true)
      dispatch(action({ type })).catch(() => {
        setSaving(false)
      })
    },
    [setSaving, dispatch]
  )

  return (
    <>
      <Heading css={styles.heading} />
      <div css={styles.container}>
        <OAuthButtonV2
          id="signup-google"
          key="google"
          onClick={propFunc(doSignup, doGoogleSignup)}
          customIcon={<GoogleLogo />}
          text="Sign up with Google"
          savingText="Signing up…"
          saving={saving}
          tracking={getTracking()}
          dark
        />
        <OAuthButtonV2
          id="signup-email"
          size="xBig"
          css={styles.signupWithEmail}
          onClick={propFunc(doSignup, doEmailSignup)}
          customIcon={<Mail />}
          text="Sign up with email"
        />
      </div>
    </>
  )
}

export default SignupPage
